import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.orange.darken3,
        secondary: colors.grey.darken4,
        accent: colors.orange.accent3,
        error: colors.red.accent3,
      }
    },
  },
});